export default function getAssetPath(path: string): string {
  const prefix = process.env.BASE_URL || '/';
  return prefix + path;
}
